import css from 'styled-jsx/css';

const styles = css.global`#renegociacao25-emp-canais {
  padding: 40px 0;
  overflow: hidden;
}

#renegociacao25-emp-canais .canais-principal {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

#renegociacao25-emp-canais .canais-principal .canais-textos {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

#renegociacao25-emp-canais .canais-textos .canais-titulo {
  color: #C00;
  font-family: "SantanderHeadline";
  font-size: 24px;
  font-style: normal;
  font-weight: 400;
  line-height: 36px;
}

#renegociacao25-emp-canais .canais-textos .canais-texto {
  color: #444;
  font-family: "SantanderText";
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 28px;
}

#renegociacao25-emp-canais .canais-carrossel .slide {
  border-radius: 4px;
  background: #FFF;
  box-shadow: 0px 4px 8px 0px rgba(34, 34, 34, 0.12);
  width: 240px;
  height: 138px;
  margin-right: 24px;
  flex: 0 0 240px;
}

#renegociacao25-emp-canais .canais-carrossel .slide-contain {
  width: 240px;
  height: 138px;
  cursor: pointer;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  position: relative;
}

#renegociacao25-emp-canais .canais-carrossel .slide-contain .qrcode-whatsapp {
  position: absolute;
  width: 110px;
  right: 16px;
}

#renegociacao25-emp-canais .canais-carrossel .canais-card-img-titulo {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
}

#renegociacao25-emp-canais .canais-carrossel .canais-card-titulo {
  color: #444;
  font-family: "SantanderMicroText";
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 22px;
}

#renegociacao25-emp-canais .canais-carrossel .canais-card-link {
  color: #C00;
  font-family: "SantanderText";
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 28px; /* 155.556% */
  text-decoration-line: underline;
  text-decoration-style: solid;
  text-decoration-skip-ink: none;
  text-decoration-thickness: auto;
  text-underline-offset: auto;
  text-underline-position: from-font;
}

#renegociacao25-emp-canais .canais-carrossel .canais-card-link.link-email {
  font-size: 16px;
}

#renegociacao25-emp-canais .canais-carrossel .home-pagination {
  margin-top: 24px;
}

#renegociacao25-emp-canais .home-pagination .embla__prev {
  background-image: url(assets/renegociacao25/canais/ic_arrow_l.svg);
}

#renegociacao25-emp-canais .home-pagination .embla__next {
  background-image: url(assets/renegociacao25/canais/ic_arrow_r.svg);
}

#renegociacao25-emp-canais .home-pagination .embla__prev, 
#renegociacao25-emp-canais .home-pagination .embla__next {
  width: 24px;
  height: 24px;
  background-size: 24px 24px;
}

@media (min-width: 992px) {
  #renegociacao25-emp-canais {
    padding: 40px 0 66px;
    overflow: hidden;
  }

  #renegociacao25-emp-canais .img-separador-reneg  {
    padding-top: 66px;
  }

  
  #renegociacao25-emp-canais .home-pagination {
    display: none;
  }

}`;

export default styles;